import React from 'react'
import Icon from '@mdi/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import type { SvgIconProps } from '@mui/material'
type IconComponentProps = {
  size?: number
  color?: string
}

export function createMdiWrapper(path: string): React.ComponentType<IconComponentProps> {
  return function MdiIconWrapper({ size = 24, color }: IconComponentProps) {
    return <Icon path={path} size={size / 24} color={color ?? undefined} />
  }
}

export function createFontAwesomeWrapper(
  iconDef: IconDefinition
): React.ComponentType<IconComponentProps> {
  return function FontAwesomeIconWrapper({ size = 24, color }: IconComponentProps) {
    return (
      <FontAwesomeIcon
        icon={iconDef}
        style={{ width: size, height: size, color: color ?? undefined }}
      />
    )
  }
}

/**
 * Wraps MUI SvgIcon for consistent (size) API.
 * MUI uses fontSize prop or sx.
 */
export function createMuiWrapper(
  MuiIconComponent: React.ComponentType<SvgIconProps>
): React.ComponentType<IconComponentProps> {
  return function MuiIconWrapper({ size = 24, color }: IconComponentProps) {
    return (
      <MuiIconComponent
        sx={{
          width: size,
          height: size,
          fontSize: size,
          color: color ?? 'inherit',
        }}
        fontSize="inherit"
      />
    )
  }
}
